import {Component, OnDestroy, OnInit} from '@angular/core';
import {MenuItem} from 'primeng/api';
import {DialogService} from 'primeng/dynamicdialog';
import {Subject} from 'rxjs';
import {takeUntil} from 'rxjs/operators';
import {Location} from '@angular/common';
import {environment} from '../../../../environments/environment';
import {LogoutConfirmComponent} from './logout-confirm/logout-confirm.component';
import {LmsHeaderCommonService} from './service/lms-header-common.service';
import {UserData} from './service/lms-header-common.model';
import {RoleGroup} from "../../role";

@Component({
  selector: 'app-lms-header',
  templateUrl: './lms-header.component.html',
  styleUrls: ['./lms-header.component.scss'],
})
export class LmsHeaderComponent implements OnInit, OnDestroy {
  public selectedUser: string;
  public showButton = false;
  public currentRouteLabel = '';
  private readonly destroy$ = new Subject<void>();

  constructor(
    private readonly dialogService: DialogService,
    private readonly lmsHeaderCommonService: LmsHeaderCommonService,
    private readonly location: Location,
  ) { }

  public items: MenuItem[];

  ngOnInit(): void {
    this.getUserById();

    this.lmsHeaderCommonService.getShowButton()
      .pipe(takeUntil(this.destroy$))
      .subscribe(value => (this.showButton = value));

    this.lmsHeaderCommonService.getbreadCrumLable()
      .pipe(takeUntil(this.destroy$))
      .subscribe(label => (this.currentRouteLabel = label));
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  backClicked(): void {
    this.location.back();
  }

  getUserById(): void {
    setTimeout(() => {
      if (localStorage.getItem('token') !== null) {
        this.lmsHeaderCommonService
          .getLoggedUser()
          .subscribe((res: UserData) => {
            this.lmsHeaderCommonService.setLoggedInUserData(res);
            const userName = res.attributes.name ?? `${res.attributes.firstName} ${res.attributes.lastName}`;
            this.selectedUser = RoleGroup.isCustomerRoleString(res.role) ? userName
              : `${userName} (${res.role.replace('rc_', '')})`;
            this.setList();
          });
      }
    }, 2000);
  }

  setList(): void {
    this.items = [
      {
        label: 'Logout',
        command: (event) => {
          this.selectedMenuItem(event);
        },
      },
    ];
  }

  selectedMenuItem(event): void {
    this.selectedUser = event.item.label;
    if (event.item.label === 'Logout') {
      this.logoutConfirmModal();
    }
  }

  logoutConfirmModal(): void {
    if (localStorage.getItem('token')) {
      this.dialogService.open(LogoutConfirmComponent, {
        data: {},
        header: 'Confirm',
        styleClass: 'common-dialog',
        width: '35%',
        height: 'auto',
      });
      this.lmsHeaderCommonService.getLoggedInUserData().subscribe(res => {
        this.selectedUser = RoleGroup.isCustomerRoleString(res.roles[0]) ? `${res.attributes.firstName} ${res.attributes.lastName}`
          : `${res.attributes.firstName} ${res.attributes.lastName} (${res.roles[0].replace('rc_', '')})`;
        this.selectedUser = `${res.attributes.firstName} ${res.attributes.lastName} (${res.roles[0].replace('rc_', '')})`;
        this.setList();
      });
    } else {
      window.open(environment.redirectUrl, '_self');
    }
  }
}
